import React, { Component } from 'react';
import { resolvePublicAssets } from '../../../../utils';
import './style.scss';

interface CustomerProfileItemProps {
  text: string;
  correct?: boolean;
}

interface CustomerProfileItemState {}

class CustomerProfileItem extends Component<
  CustomerProfileItemProps,
  CustomerProfileItemState
> {
  componentDidMount() {}

  render() {
    const { text, correct } = this.props;
    const iconPath = correct
      ? 'assets/images/customer-profile/icon-li-dot.svg'
      : 'assets/images/customer-profile/icon-li-red-dot.svg';
    return (
      <div
        className={`customer-profile-item content-align-level ${
          !correct ? 'customer-profile-item-warning' : ''
        }`}
      >
        <div className="customer-profile-item__img">
          <img src={resolvePublicAssets(iconPath)} alt="" />
        </div>
        <div className="customer-profile-item__span">{text}</div>
      </div>
    );
  }
}

export default CustomerProfileItem;
